import axios from "axios/index";
import { API } from "../utilities/api.config";
import { clientAction } from ".";

function linkAccount(payload) {
  return (dispatch) => {
    dispatch({
      type: "REDTAIL_API_REQUESTED",
    });
    axios
      .post(API.REDTAIL_LINK_ACCOUNT, payload)
      .then((response) => {
        dispatch({
          type: "REDTAIL_LINK_ACCOUNT_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "REDTAIL_LINK_ACCOUNT_FAIL",
          payload: error,
        });
      });
  };
}

function unlinkAcount(payload) {
  return (dispatch) => {
    dispatch({
      type: "REDTAIL_API_REQUESTED",
    });
    axios
      .post(API.REDTAIL_UNLINK_ACCOUNT, payload)
      .then((response) => {
        dispatch({
          type: "REDTAIL_UNLINK_ACCOUNT_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "REDTAIL_UNLINK_ACCOUNT_FAIL",
          payload: error,
        });
      });
  };
}

function getFamilies() {
  return (dispatch) => {
    dispatch({
      type: "REDTAIL_API_REQUESTED",
    });
    axios
      .get(API.REDTAIL_SEARCH_FAMILIES)
      .then((response) => {
        dispatch({
          type: "REDTAIL_GET_FAMILIES_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "REDTAIL_GET_FAMILIES_FAIL",
          payload: error,
        });
      });
  };
}

function searchFamilies(searchString) {
  return (dispatch) => {
    dispatch({
      type: "REDTAIL_API_REQUESTED",
    });
    axios
    .get(API.REDTAIL_SEARCH_FAMILIES, { params: { query: searchString }})
    .then((response) => {
        dispatch({
          type: "REDTAIL_SEARCH_FAMILIES_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "REDTAIL_SEARCH_FAMILIES_FAIL",
          payload: error,
        });
      });
  };
}

function clearFamilies() {
  return (dispatch) =>
    dispatch({
      type: "REDTAIL_CLEAR_FAMILIES",
    });
}

function queueImportJob(payload, searchString) {
  return (dispatch) => {
    dispatch({
      type: "REDTAIL_QUEUE_IMPORT_JOB_REQUESTED",
    });
    axios
      .post(API.REDTAIL_IMPORT_FAMILIES, payload, { params: { query: searchString }})
      .then((response) => {
        dispatch({
          type: "REDTAIL_QUEUE_IMPORT_JOB_SUCCESS",
          payload: response.data,
        });
      })
      .then(() => dispatch(lastImportJob()))
      .catch((error) => {
        dispatch({
          type: "REDTAIL_QUEUE_IMPORT_JOB_FAIL",
          payload: error,
        });
      });
  };
}

function lastImportJob() {
  return (dispatch, getState) => {
    dispatch({
      type: "REDTAIL_LAST_IMPORT_JOB_REQUESTED",
    });
    const delay = 5;
    const unlimitedInterval = setInterval(() => {
      axios
        .get(API.REDTAIL_LAST_IMPORT_JOB)
        .then((response) => {
          dispatch({
            type: "REDTAIL_LAST_IMPORT_JOB_SUCCESS",
            payload: response.data,
          });
          dispatch(clientAction.getClients());
        })
        .then(() => {
          const { runningJob } = getState().redtail;
          if (!runningJob) {
            clearInterval(unlimitedInterval);
          }
        })
        .catch((error) => {
          dispatch({
            type: "REDTAIL_LAST_IMPORT_JOB_FAIL",
            payload: error,
          });
        });
    }, delay * 1000);
  };
}

function clearMessage() {
  return (dispatch) =>
    dispatch({
      type: "REDTAIL_CLEAR_MESSAGE",
    });
}

function clearJob() {
  return (dispatch) =>
    dispatch({
      type: "REDTAIL_CLEAR_JOB",
    });
}

function resetPassword() {
  return (dispatch) => {
    dispatch({
      type: "REDTAIL_API_REQUESTED",
    });
    axios
      .get(API.REDTAIL_RESET_PASSWORD)
      .then((response) => {
        dispatch({
          type: "REDTAIL_RESET_PASSWORD_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "REDTAIL_RESET_PASSWORD_ERROR",
          payload: error,
        });
      });
  };
}

export const redtailAction = {
  linkAccount,
  unlinkAcount,
  getFamilies,
  searchFamilies,
  clearFamilies,
  queueImportJob,
  lastImportJob,
  clearMessage,
  clearJob,
  resetPassword,
};

export default redtailAction;



// WEBPACK FOOTER //
// ./src/actions/redtail.action.js